import React from "react";
import Wordmark from "../Wordmark";

export default function Footer() {
    return (
        <footer
            id="footer"
            data-testid="section-footer"
            style={{
                backgroundColor: "var(--bt-paper)",
                borderTop: "1px solid var(--bt-rule)",
                paddingTop: 56,
                paddingBottom: 40,
            }}
        >
            <div className="bt-shell">
                <div
                    className="bt-footer-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 40,
                    }}
                >
                    <div>
                        <Wordmark size="sm" />
                        <p
                            className="t-meta"
                            style={{
                                marginTop: 16,
                                color: "var(--bt-mute)",
                                lineHeight: 1.6,
                                maxWidth: 280,
                            }}
                        >
                            Published by Brass Tacks Research LLC.<br />
                            [Address, once LLC is filed]
                        </p>
                    </div>

                    <FooterCol
                        title="Read"
                        links={[
                            { href: "#sample-issue", label: "Sample issue" },
                            { href: "#whats-in-brief", label: "What's in the brief" },
                            { href: "#recap", label: "Subscribe" },
                        ]}
                    />

                    <FooterCol
                        title="Site"
                        links={[
                            { href: "/editorial", label: "Editorial Standards" },
                            { href: "/disclosure", label: "Disclosure & Affiliations" },
                            { href: "/privacy", label: "Privacy Policy" },
                            { href: "/terms", label: "Terms of Service" },
                            { href: "/ccpa-opt-out", label: "Your California Rights" },
                            { href: "mailto:hello@brasstacksbrief.com", label: "Contact" },
                        ]}
                    />

                    <div>
                        <p
                            className="signal"
                            style={{ marginBottom: 14, color: "var(--bt-mute)" }}
                        >
                            Disclaimer
                        </p>
                        <p
                            className="t-meta"
                            style={{
                                margin: 0,
                                lineHeight: 1.65,
                                color: "var(--bt-mute)",
                                maxWidth: 380,
                            }}
                        >
                            Brass Tacks Research LLC is a publisher, not a registered
                            investment advisor. Information provided in the brief and
                            on this site is for educational and informational purposes
                            only and does not constitute financial, investment, tax, or
                            legal advice. Consult a licensed professional before making
                            financial decisions.
                        </p>
                        <p
                            className="t-meta"
                            style={{
                                marginTop: 14,
                                marginBottom: 0,
                                lineHeight: 1.65,
                                color: "var(--bt-mute)",
                                maxWidth: 380,
                            }}
                        >
                            SMS: Reply STOP to unsubscribe, HELP for help. Message and
                            data rates may apply.
                        </p>
                    </div>
                </div>

                <hr className="hairline" style={{ marginTop: 48, marginBottom: 24 }} />

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 16,
                        flexWrap: "wrap",
                    }}
                >
                    <p className="t-meta" style={{ margin: 0, color: "var(--bt-mute)" }}>
                        &copy; 2026 Brass Tacks Research LLC. All rights reserved.
                    </p>
                    <p className="t-meta" style={{ margin: 0, color: "var(--bt-mute)" }}>
                        Set in Fraunces and Newsreader.
                    </p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, links }) {
    return (
        <nav aria-label={title}>
            <p className="signal" style={{ marginBottom: 14, color: "var(--bt-mute)" }}>
                {title}
            </p>
            <ul role="list" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {links.map((l) => (
                    <li key={l.href} style={{ marginBottom: 10 }}>
                        <a
                            href={l.href}
                            className="bt-link"
                            style={{
                                fontFamily: "Newsreader, serif",
                                fontSize: 15,
                                color: "var(--bt-ink-soft)",
                                textDecorationColor: "transparent",
                            }}
                            data-testid={`footer-link-${l.label
                                .toLowerCase()
                                .replace(/[^a-z]+/g, "-")}`}
                        >
                            {l.label}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
